<template>
  <div class="detail">
    <div
      v-if="relation.stts==3"
      class="table">
      <div class="th flex-sb-center">
        <span>Renewal Notice by Mail</span>
        <v-text-switch
          v-model="is_send_notice"
          :disabled="relation.send_notice_stts!=1"
          @change="handleChangeSendNotice"></v-text-switch>
      </div>
      <div class="tr">
        <span>Mail Status</span>
        <span class="flex flex-sb-center">
          <span>{{relation.send_notice_stts_language||'-'}}</span>
          <span>
            <v-button
              green
              :disabled="isSent"
              @click="handleChangeStatus">Change Mail Status</v-button>
          </span></span>
      </div>
      <div class="tr">
        <span>Sent Date</span>
        <span>{{relation.send_notice_date||'-'}}</span>
      </div>
      <div class="tr">
        <span>Handler</span>
        <span>{{relation.handler_nm||'-'}}</span>
      </div>
      <div class="tr">
        <span>Remarks</span>
        <span>{{relation.change_mail_remark||'-'}}</span>
      </div>
      <div class="tr">
        <span>Renewal Notice</span>
        <span
          v-if="relation.notice_url"
          class="color-blue pointer"
          @click="openUrl(relation.notice_url)">Download</span>
      </div>
      <div
        v-if="renewal_letter_insurer"
        class="tr">
        <span>Renewal Letter（Insurer）</span>
        <span
        >
          <file-container
            is-show-detail
            is-renew-type
            is-viewer
            :fileData="renewal_letter_insurer"
          />
        </span>
      </div>
    </div>
    <div class="flex-sb-center detail_title">
      <div class="">Reminder</div>
      <v-button
        gray
        @click="handleEidt">{{file.length>0?'Edit':'Add'}}</v-button>
    </div>
    <div class="document-form sme-container__info sme-container__info-document">
      <p
        v-if="file.length<=0"
        class="fs-14 color-dark">No Record</p>
      <template v-else>
        <div class="table table_no_title" >
          <div
            v-for="(item,index) in file"
            :key="'file_'+index"
            class="form-item tr">
            <file-container
              is-show-detail
              is-renew-type
              is-viewer
              :fileData="item"
            />
          </div>
        </div>
      </template>
    </div>
    <div class="box box-remark mg-t-20">
      <div class="flex-sb-center detail_title">
        <div class="">Reminder Remarks</div>
      </div>
      <div class="remarks-container">
        <div
          v-for="(item, index) in reminder_remark"
          :key="index"
          class="remark-box">
          <div class="remark-header mg-b-5">
            <span class="fs-12 fw-600 color-gray60">{{ item.cs_nm }}</span>
            <span  class="fs-12 color-gray60">{{ item.created_at }}</span>
          </div>
          <p
            class="fs-12  color-dark"
            v-html="changeLineData(item.remark)"></p>
        </div>
      </div>
      <div class="remark-add mg-t-20">
        <v-input
          v-model="message"
          class="mg-b-15"
          append="Add"
          type="textarea"
          :rows="4"
          @handlerAppend="handlerSendRemark"/>
        <div class="text-right">
          <v-button
            green
            :disabled="!message"
            @click="handlerSendRemark">Add Remarks</v-button>
        </div>
      </div>
    </div>
    <update-mail-status
      v-model="showMailStatus"
      :form="relation"
      is-reminder-detail
      :status-id-arr="status_list"
      @update="handleUpdate"></update-mail-status>
  </div>
</template>

<script>
import MixinOptions from '@/mixins/options'
import updateMailStatus from '@/views/renew/components/updateMailStatus'
import {createRenewalReminderRemark,setRenewalMailNotice} from '@api/renewal'
export default {
  name: 'renew-ticket-detail',
  components:{
    updateMailStatus
  },
  mixins: [MixinOptions],
  props:{
    form:{
      type:Object,
      default:()=>({})
    }
  },
  data(){
    return{
      remarkList:[],
      message:'',
      is_send_notice:0,
      showMailStatus:false
    }
  },
  computed:{
    isSent(){
      let {send_notice_stts} = this.relation||{}
      return send_notice_stts == 3
    },
    status_list(){
      let {id} = this.relation
      return [id]
    },
    isFina(){
      let {merchant_platform} = this.form||{}
      return merchant_platform==2
    },
    productId(){
      let {order_detail} = this.form||{}
      let {product_id} = order_detail||{}
      return  product_id||''
    },
    relation(){
      let {relation} = this.form||{}
      return relation
    },
    renewal_letter_insurer(){
      let {renewal_letter_insurer={}} = this.relation||{}
      let data = {
        ...renewal_letter_insurer,
        thumb_url:renewal_letter_insurer.url,
        client_name:renewal_letter_insurer.name
      }
      return data||{}
    },
    isCompany(){
      let {customer} = this.form||{}
      let {identity} = customer||{}
      return identity==2
    },
    reminder_remark(){
      let {reminder_remark} = this.relation||{}
      return reminder_remark||[]
    },
    file(){
      let {file} = this.relation||{}
      return file||[]
    },
    ticket_id(){
      let {ticket_id} = this.$route.query||{}
      return ticket_id
    }
  },
  watch:{
    form:{
      immediate:true,
      handler(val){
        let {relation,} = val||{}
        let {reminder_remark,is_send_notice} = relation||{}
        this.remarkList = reminder_remark||[]
        this.is_send_notice = is_send_notice
      }
    }
  },
  methods:{
    handleChangeStatus(){
      this.showMailStatus = true
    },
    handleUpdate(){
      this.$emit('update')
    },
    handleEidt(){
      this.$emit('edit')
    },
    handleChangeSendNotice(){
      this.network().setRenewalMailNotice()
    },
    handlerSendRemark() {
      let remark = this.message
      this.network().createRenewalReminderRemark({
        remark
      })
    },
    network(){
      return{
        createRenewalReminderRemark: async (params) => {
          const { data } = await createRenewalReminderRemark({
            ticket_id:this.ticket_id,
            ...params
          })
          this.message = ''
          this.$emit('update')
        },
        setRenewalMailNotice: async (params) => {
          const { data } = await setRenewalMailNotice({
            ticket_id:this.ticket_id,
            is_send:this.is_send_notice
          })
          this.$emit('update')
        },
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../quoting/sme/info";
.document-table{
  .tr:last-child{
    border-bottom-left-radius: 0px!important;
    border-bottom-right-radius: 0px!important;
  }
}
.detail{
  .detail_title{
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    display: flex;
    align-items: center;
    color: #24292E;
    margin-bottom: 20px;
  }

  .table {
    //border: 1px solid #E1E4E8;
    &.table_no_title{
      .tr:first-child{
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        border: 1px solid #E1E4E8;
      }
    }
    .table_tr_border0{
      .tr:last-child{
        border-radius: 0!important;
      }
    }
    .th{
      padding: 16px;
      background: $gray;
      border: 1px solid #E1E4E8;
      border-top-left-radius: 6px;
      border-top-right-radius: 6px;
      color: $dark!important;
      font-weight: 600;
    }
    .tr {
      padding: 8px 16px;
      border: 1px solid #E1E4E8;
      border-top: 0;
      background: #fff!important;
      display: flex;
      align-items: center;

      /* Text/text-gray */

      color: #586069;
      &.tr-gray__title{
        background: $gray!important;
        span{
          color: #24292E!important;
        }
        .key-alt-down{
          color: #0366D6!important;
          cursor: pointer!important;
        }
      }
      span{
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #586069;
        &:nth-child(2){
          color: #24292E!important;
          &.orange{
            color:  #B08800!important;
          }
          &.color-blue{
            color: #0366D6!important;
          }
          &.key-alt-down{
            color: #0366D6!important;
            cursor: pointer!important;
          }
        }
      }
      .fw-600{
        font-weight: 600;
      }
      .top-algin{
        align-self: baseline;
      }
      .compare {
        display: flex;
        align-items: center;
        & > span {
          flex: 1;
        }
      }
      &:nth-child(2n){
        background: #fff;
      }
      &:last-child{
        //border: 0;
        border-bottom-left-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
  }
}
.color-blue{
  color: #0366D6!important;
}
.remark-header {
  display: flex;
  justify-content: space-between;
}
</style>
